import React, { useState, useEffect, useRef } from 'react'
import { Redirect } from "react-router-dom";
import Loader from '../../Utils/Loader/NewLoader2025'
import { Site, handleLoggersToBeUnassigned, deleteRow, handleTextFieldChange, Boundary, Company, GPS, defaultCenter, reloadData, handleSiteChange, Coordinates, BoundaryStyling, Name } from '../../components/Site Functions/LoadSiteData'
import { APILoggerDetail, buildAPILoggerDetail } from 'models/APILoggerDetail';
import { primaryColor } from '../../assets/jss/material-dashboard-react'
import { useTabletContext, useMobileLandscape } from '../../Context/ContextProvider'
import GoogleMapsMultiPolygon from '../../components/Map/NewGoogleMaps2024MultiPolygon';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
import { isLCLLogger } from 'variables/chariotProductIds';
import type { google } from 'google.maps'
import FullWidthMobileButton from '../../components/FullWidthMobileButton';
import { Accordion, Item, AccordionTypes } from 'devextreme-react/accordion';
import { DataGrid, Column, GroupPanel, Grouping, FilterRow, Pager, Paging, StateStoring, Format, Export, HeaderFilter } from 'devextreme-react/data-grid';
import { Menu, Chip, useTheme, MenuItem } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import UploadDialog from "../../components/ImageUpload/UploadDialog"
import SlideInAnimation from '../../Animation Wrappers/SlideInAnimation';
import SiteModalMobile from './SiteModalMobile'
import { injectIntl, FormattedMessage, IntlShape, useIntl } from 'react-intl';
import Modal from 'react-bootstrap/Modal'

interface Props {
    classes: {
        cardTitleWhite: string;
        formControl: string;
        cardCategoryWhite: string;
    };
    history: {
        goBack: () => void;
    };
    location: {
        state: {
            serial: number | null
        };

    };
}

interface RedirectProps {
    siteName: string;
    siteId: number | null;
    serial: string;
    deviceId: number | null;
}

const SitesMobile: React.FC<Props> = () => {
    locale(sessionStorage.getItem("language"));
    loadMessages(frMessages);
    loadMessages(deMessages);
    loadMessages(esMessages);
    loadMessages(ptMessages);



   
    //hooks
    const intl = useIntl()
    const isLandscape = useMobileLandscape()
    const isTablet = useTabletContext()

    //state
    const [authorized, setAuthorized] = useState<boolean>(true)
    const [activeSites, setActiveSites] = useState<Array<Site>>([])
    const [inactiveSites, setInactiveSites] = useState<Array<Site>>([])
    const [redirect, setRedirect] = useState<boolean>(false)
    const [redirectPath, setRedirectPath] = useState<string>("")
    const [redirectProps, setRedirectProps] = useState<RedirectProps>({
        siteName: "",
        siteId: null,
        serial: "",
        deviceId: null
    })
    const [anchorEl, setAnchorEl] = useState<HTMLElement>()
    const [tempSite, setTempSite] = useState<Site>({
        siteName: "",
        siteNameUserFriendly: "",
        loggers: [],
        latitude: 0,
        longitude: 0,
        createdDate: undefined,
        fkCompanyId: parseInt(sessionStorage.getItem('companyId') || '0'),
        defaultSite: false,
        fkEASiteId: null,
    })
    const [imageDialog, setImageDialog] = useState(false)
    const [modal, setModal] = useState(false)
    const [modalTitle, setModalTitle] = useState<string>("")
    const [selectedTab, setSelectedTab] = useState<number>(0)
    const [loggersToBeAssigned, setLoggersToBeAssigned] = useState<Array<APILoggerDetail>>([])
    const [editSite, setEditSite] = useState<boolean>(false)
    const [deleteModal, setDeleteModal] = useState<boolean>(false)
    const [loggersToBeUnassigned, setLoggersToBeUnassigned] = useState<Array<APILoggerDetail>>([])
    const [markers, setMarkers] = useState<Array<GPS>>([])
    const [boundaries, setBoundaries] = useState<Array<Boundary>>([])
    const activeGridRef = useRef(null)
    const inactiveGridRef = useRef(null)
    const mapRef = useRef(null)
    const anchorElRef = useRef(null);
    const [showTooltip, setShowTooltip] = useState<boolean>(false)
    const [hoveredBoundary, setHoveredBoundary] = useState<Site>({})
    const [tooltipHovered, setTooltipHovered] = useState<boolean>(false)
    const [mouseOverBoundary, setMouseOverBoundary] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [companies, setCompanies] = useState<Array<Company>>([])
    const [googleMapInstance, setGoogleMapInstance] = useState<google.maps.Map | null>()
    const [showMap, setShowMap] = useState<boolean>(false)
    ///useeffect

    useEffect(() => {
        reloadData(
            setLoading,
            setBoundaries,
            companies,
            setCompanies,
            setMarkers,
            setActiveSites,
            setInactiveSites,
            setLoggersToBeAssigned,
            setAuthorized
        )
    }, [])



    const onMapLoad = (map: google.maps.Map): void => {
        map.setMapTypeId("hybrid");
        setGoogleMapInstance(map);

        // Call fitBounds directly with the map instance instead of relying on state
        if (markers.length > 0 || boundaries.length > 0) {
            fitBoundsToMarkersWithMap(map);
        } else {
            map.setZoom(10);
        }
    };

    const fitBoundsToMarkersWithMap = (mapInstance: google.maps.Map): void => {
        if (markers.length > 0 || boundaries.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();

            markers.forEach((marker) => {
                bounds.extend(marker.position);
            });

            if (boundaries.length > 0) {
                boundaries.forEach(boundary => {
                    if (Array.isArray(boundary.path)) {
                        boundary.path.forEach((corner) => {
                            bounds.extend(corner);
                        });
                    }
                });
            }

            mapInstance.fitBounds(bounds);
        }
    };




    const handlePolygonClick = (siteId: number): void => {

        let boundaryClicked = activeSites.filter(site => site.siteId === siteId)[0]
        if (!boundaryClicked) {
            boundaryClicked = inactiveSites.filter(site => site.siteId === siteId)[0]
        }
        if (boundaryClicked) {
            setRedirect(true)
            setRedirectPath('/portal/SiteDetail')
            setRedirectProps({
                siteName: boundaryClicked.siteNameUserFriendly || boundaryClicked.siteName,
                siteId: boundaryClicked.siteId,
                serial: '',
                deviceId: null
            })
        } else alert(intl.formatMessage({ id: 'Error finding site details' }))
    }


    const handleMouseOverPolygon = (siteId: number, e: React.MouseEvent): void => {
        setMouseOverBoundary(true)


        const boundaryHovered = activeSites.filter(site => site.siteId === siteId)[0]
        setShowTooltip(true)
        setHoveredBoundary(boundaryHovered)
    }

    const handleMouseLeavePolygon = (): void => {
        setMouseOverBoundary(false)
        setTimeout(() => {
            if (!tooltipHovered) {
                setShowTooltip(false)
            }
        }, 2000)
    }

    const handleMouseOverTooltip = (e): void => {
        e.stopPropagation()
        setTooltipHovered(true)
    }
    const handleMouseLeaveTooltip = (): void => {
        setTooltipHovered(false)
        if (!mouseOverBoundary) {
            setShowTooltip(false)
        }
    }

    const handleEditClick = (e, siteId: number): void => {
        e.stopPropagation()
        const selectedSite = activeSites.filter(site => site.siteId === siteId)[0]
        setTempSite(selectedSite)
        toggleEditModal()
    }

    const toggleEditModal = (): void => {
        if (modal) {
            setTempSite({
                siteName: "",
                siteNameUserFriendly: "",
                loggers: [],
                latitude: 0,
                longitude: 0,
                createdDate: undefined,
                fkCompanyId: parseInt(sessionStorage.getItem('companyId') || '0'),
                defaultSite: false,
                fkEASiteId: null,
            })
            setEditSite(false)
        } else {
            setEditSite(true)
        }
        setModal(!modal)
        setModalTitle(intl.formatMessage({ id: 'Edit Site -' }))
        setAnchorEl(null)


    }

    const handleMarkerClick = (marker) => {
        const relatedSite = activeSites.filter(site => site.loggers.map(logger => logger.serial).includes(marker.serial))[0]
        setRedirect(true)
        setRedirectPath('/portal/SiteDetail')
        setRedirectProps({
            siteName: relatedSite.siteNameUserFriendly || relatedSite.siteName,
            siteId: relatedSite.siteId,
            serial: '',
            deviceId: null
        })
    }   

    const handleChipClick = (serial: number, loggerId: number): void => {

        const clickedChip = activeSites
            .find(site => site.loggers.some(logger => logger.serial === serial))
            ?.loggers.find(logger => logger.serial === serial);
        setRedirect(true)
        setRedirectPath(!isLCLLogger(clickedChip.model) ? '/portal/DeviceDetail' : '/portal/LCLDeviceDetail')
        setRedirectProps({
            serial: serial,
            mapKey: 'test'
        })
    }

    const toggleNewModal = (): void => {
        setTempSite({
            siteName: "",
            siteNameUserFriendly: "",
            loggers: [],
            latitude: 0,
            longitude: 0,
            createdDate: undefined,
            fkCompanyId: parseInt(sessionStorage.getItem('companyId') || '0'),
            defaultSite: false,
            fkEASiteId: null,
        })
        openNewSiteModal()

    }

    const openNewSiteModal = (): void => {
        setModal(!modal)
        setModalTitle(intl.formatMessage({ id: 'New Site' }))
        setAnchorEl(null)
        setEditSite(false)
    }

    const renderSiteName = (data) => {
        const theme = useTheme()

        return (<Chip
            label={data.data.siteNameUserFriendly}
            onClick={(): void => handlePolygonClick(data.data.siteId)}
            sx={{ backgroundColor: theme.palette.grey.main, color: theme.palette.grey.contrastText }}
        />)

    }

    const handleDeviceRender = ({ data }):React.ReactNode => {
        return data.loggers.length
        
    }

    const toggleSiteDetail = () => {
        setRedirect(true)
        setRedirectPath('/portal/SiteDetail')
        setRedirectProps({
            siteName: tempSite.siteNameUserFriendly || tempSite.siteName,
            siteId: tempSite.siteId,
            serial: '',
            deviceId: null
        })
    }

    const toggleImageModal = (): void => {
        setImageDialog(!imageDialog)
        setAnchorEl(null)
    }

    const toggleDeleteModal = () => {
        setModalTitle(intl.formatMessage({ id: 'Delete Site' }))
        setDeleteModal(!deleteModal)
        setAnchorEl(null)
    }

    const moreRender = (site: any): React.ReactNode => {
        return (
            <div style={{ display: "flex", justifyContent: "center" }}>
                <IconButton size="small" onClick={(e): void => { handleClick(e, site) }}><MoreHorizIcon /></IconButton>
            </div>)
    }

    const handleClick = (event: any, site: Site): void => {
        setAnchorEl(event.currentTarget)
        setTempSite(site)
    }

    const handleClose = () => {
        setAnchorEl(null);
        setTempSite({
            siteName: "",
            siteNameUserFriendly: "",
            loggers: [],
            latitude: 0,
            longitude: 0,
            createdDate: undefined,
            fkCompanyId: parseInt(sessionStorage.getItem('companyId') || '0'),
            defaultSite: false,
            fkEASiteId: null,
        })
    }

    return (
            !redirect ?
                <div>
                    {loading &&
                        <div style={{
                            position: 'absolute', left: 'Calc(50% - 100px)', top: 'Calc(50% - 100px)',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 13000
                        }}>
                        <Loader color={undefined} />
                        
                        </div>
                }
                {!loading && <>
                    {companies.length > 0 && <SiteModalMobile
                        open={modal}
                        modalTitle={`${modalTitle} ${tempSite?.siteNameUserFriendly ? tempSite?.siteNameUserFriendly : ""}`}
                        onCancel={toggleEditModal}
                        site={tempSite}
                        handleTextFieldChange={(name: string, value: string): void => {
                            handleTextFieldChange(
                                name,
                                value,
                                tempSite,
                                setTempSite
                            )
                        }}
                        unAssignedLoggers={loggersToBeAssigned}
                        selectedLogger={location.state?.serial ? location.state.serial : null}
                        editSite={editSite}
                        handleLoggersToBeUnassigned={(logger): void => {
                            handleLoggersToBeUnassigned(
                                logger,
                                loggersToBeUnassigned,
                                tempSite,
                                setTempSite,
                                setLoggersToBeUnassigned
                            )
                        }
                        }
                        onSubmit={(selected: APILoggerDetail[], assignDate: Date, polygonPath: Coordinates[], boundaryStyling: BoundaryStyling, hasBoundary: boolean, tempName: Name, companyId: number): void => handleSiteChange(
                            selected,
                            assignDate,
                            polygonPath,
                            boundaryStyling,
                            hasBoundary,
                            tempName,
                            companyId,
                            editSite,
                            tempSite,
                            intl,
                            setLoading,
                            setBoundaries,
                            companies,
                            setCompanies,
                            setMarkers,
                            setActiveSites,
                            setInactiveSites,
                            setLoggersToBeAssigned,
                            setLoggersToBeUnassigned,
                            setAuthorized,
                            loggersToBeUnassigned,
                            setSelectedTab
                        )}
                        companies={companies}
                    />}
                    <Modal
                        show={deleteModal}
                        onHide={(): void => toggleDeleteModal()}
                        dialogClassName="modal-100w"
                        aria-labelledby="example-custom-modal-styling-title"
                        centered
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="example-custom-modal-styling-title">
                                {modalTitle}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="show-grid">
                            <h4>{`${intl.formatMessage({ id: "Delete Site" })} ${tempSite.siteNameUserFriendly || tempSite.siteName} ${intl.formatMessage({ id: "AND ALL associated Readings?" })}`}</h4>
                        </Modal.Body>
                        <Modal.Footer>
                            <div style={{width: '100%', marginBottom: 10} }>
                                <FullWidthMobileButton
                                    color="primary"
                                    style={{ marginRight: "10px" }}
                                    onClick={(): void => {
                                        deleteRow(
                                            tempSite,
                                            intl,
                                            setLoading,
                                            setBoundaries,
                                            companies,
                                            setCompanies,
                                            setMarkers,
                                            setActiveSites,
                                            setInactiveSites,
                                            setLoggersToBeAssigned,
                                            setAuthorized,
                                            toggleDeleteModal
                                        )
                                    }}
                                    disabled={false}
                                    text={intl.formatMessage({ id: "Continue" })}
                                    />
                            </div>
                            <FullWidthMobileButton
                                color="secondary"
                                disabled={false}
                                onClick={(): void => toggleDeleteModal()}
                                text={intl.formatMessage({ id: "Cancel" })}
                            />

                        </Modal.Footer>
                    </Modal>
                    <UploadDialog
                        show={imageDialog}
                        title={intl.formatMessage({ id: "Upload Image" })}
                        siteId={tempSite?.siteId}
                        loggerId={0}
                        onSubmit={(): void => {
                            setImageDialog(false)
                            reloadData(
                                setLoading,
                                setBoundaries,
                                companies,
                                setCompanies,
                                setMarkers,
                                setActiveSites,
                                setInactiveSites,
                                setLoggersToBeAssigned,
                                setAuthorized)
                        }}
                        onCancel={(): void => setImageDialog(false)}
                    />
                    <h3 style={{ color: "black", marginTop: "-20px", textAlign: "center" }}>Sites</h3>
                    <div>
                        <div style={{ display: intl.locale !== 'en-GB' ? "block": "flex", justifyContent: "center", marginBottom: "10px" } }>
                            <div style={{ width: intl.locale !== 'en-GB' ? "100%" : "40%", marginRight: 8, marginBottom: intl.locale !== 'en-GB' ? '10px': '0' }}>
                                <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "Back" })} onClick={():void => history.back()} color="error" />
                            </div>
                            <div style={{ width: intl.locale !== 'en-GB' ? "100%" : "60%", marginLeft: intl.locale !== 'en-GB'? 0: 8 }}>
                                <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "Add New Site" })} onClick={():void => toggleNewModal()} color="primary" />
                            </div>
                        </div>
                        {markers.length > 0 && <div style={{ display: "flex", justifyContent: "center" }}>
                            <div style={{ width: intl.locale !== 'en-GB' ? "100%" : "90%" }}>
                                <FullWidthMobileButton disabled={false} text={showMap ? intl.formatMessage({ id: "Hide map" }) : intl.formatMessage({ id: "View Sites on Map" })} onClick={(): void => setShowMap(!showMap)} color="secondary" />
                            </div>
                        </div>}
                    </div>
                                
                    {markers.length > 0 && showMap && <SlideInAnimation direction="top" duration={0.8} delay={0} transitionAmount={100} isVisible={showMap}>
                        <div style={{ width: "100%", margin: "20px 0 0 -5px" }}>
                        <GoogleMapsMultiPolygon
                            markers={markers}
                            onMapLoad={onMapLoad}
                            boundaries={boundaries}
                            onPolygonClick={handlePolygonClick}
                            onMouseOverPolygon={showTooltip ? null : handleMouseOverPolygon}
                            onMouseLeavePolygon={handleMouseLeavePolygon}
                            showTooltip={showTooltip}
                            hoveredBoundary={hoveredBoundary}
                            onMouseOverTooltip={handleMouseOverTooltip}
                            onMouseLeaveTooltip={handleMouseLeaveTooltip}
                            onEditClick={handleEditClick}
                            handleMarkerClick={handleMarkerClick}
                            handleChipClick={handleChipClick}
                        />
                        </div>
                        </SlideInAnimation>
                }

                    <div style={{ width: (isLandscape || isTablet) ? "100%" : "120%", transform: (isLandscape || isTablet) ? "none" : "translateX(-8%)" }}>
                        <Accordion
                            collapsible={true}
                            multiple={true}
                            style={{ background: '#eeeeee', color: "black", marginTop: "20px" }}
                            defaultSelectedIndex={0}
                        >
                            <Item title={intl.formatMessage({ id: "Sites With Loggers" })}>
                                <div>
                                    <DataGrid
                                        dataSource={activeSites}
                                        allowColumnResizing={true}
                                        allowColumnReordering={true}
                                        ref={activeGridRef}
                                    >
                                        <GroupPanel visible={true} />
                                        <FilterRow visible={true} />
                                        <StateStoring enabled={true} type="localStorage" storageKey="siteListGridActive" />
                                        <Column dataField="isParent" caption={intl.formatMessage({ id: "Parent Company" })} groupIndex={0} defaultSortOrder={'desc'} />
                                        <Column dataField="companyName" groupIndex={1} caption={intl.formatMessage({ id: "Company" })} />
                                        <Column dataField="siteNameUserFriendly" dataType="string" caption={intl.formatMessage({ id: "Site Name" })} cellRender={renderSiteName} />
                                        <Column dataField="loggers" caption={intl.formatMessage({ id: "Devices" })} cellRender={handleDeviceRender} />
                                        <Column fixed={true} fixedPosition='right' type="edit" cellRender={(data): React.ReactNode => moreRender(data.data)} key='more' caption={intl.formatMessage({ id: "Action" })} width={75} />
                                    </DataGrid>
                                </div>
                            </Item>
                            <Item title={intl.formatMessage({ id: "Sites Without Loggers" })}>
                                <div>
                                    <DataGrid
                                        dataSource={inactiveSites}
                                        allowColumnResizing={true}
                                        allowColumnReordering={true}
                                        ref={activeGridRef}
                                    >
                                        <GroupPanel visible={true}/>
                                        <FilterRow visible={true}/>
                                        <StateStoring enabled={true} type="localStorage" storageKey="siteListGridInactive" />
                                        <Column dataField="isParent" caption={intl.formatMessage({ id: "Parent Company" })} groupIndex={0} defaultSortOrder={'desc'} />
                                        <Column dataField="companyName" groupIndex={1} caption={intl.formatMessage({ id: "Company" })} />
                                        <Column dataField="siteNameUserFriendly" dataType="string" caption={intl.formatMessage({ id: "Site Name" })} cellRender={renderSiteName} />
                                        <Column fixed={true} fixedPosition='right' cellRender={(data): React.ReactNode => moreRender(data.data)} key='more' caption={intl.formatMessage({ id: "Action" })} width={75} />
                                    </DataGrid>
                                </div>
                            </Item>
                        </Accordion>
                    </div>
                    {anchorEl && <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        disableScrollLock={true}
                    >
                        {sessionStorage.getItem('canConfig') === "true" && <MenuItem onClick={toggleEditModal}><FormattedMessage id="Edit" /></MenuItem>}
                        <MenuItem onClick={toggleSiteDetail}><FormattedMessage id="Details" /></MenuItem>
                        <MenuItem onClick={toggleImageModal}><FormattedMessage id="Upload Picture" /></MenuItem>
                        {sessionStorage.getItem('canConfig') === "true" && <MenuItem onClick={(): void => { toggleDeleteModal() }}><FormattedMessage id="Delete" /></MenuItem>}
                    </Menu>}
                </> }
            </div> :
            <Redirect push to={{
                pathname: redirectPath,
                state: redirectProps
            }} />
    )
}

export default SitesMobile